import "./gallery.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";

export default function Gallery() {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);

  useEffect(() => {

    // CACHE
    const cached = localStorage.getItem("galleryData");
    if (cached) {
      try {
        setImages(JSON.parse(cached));
      } catch {}
    }

    // FIRESTORE
    const ref = doc(db, "siteContent", "gallery");

    const unsub = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        const data = snap.data().items || [];
        setImages(data);
        localStorage.setItem("galleryData", JSON.stringify(data));
      }
    });

    return () => unsub();
  }, []);

  const visibleImages = images.slice(0, 3);

  return (
    <section className="gallery" id="milestones">
      <div className="gallery-container">

        <div className="gallery-header">
          <h2>Trophies & Gallery</h2>
        </div>

        <div className="gallery-grid">
          {visibleImages.map((img, i) => (
            <div
              key={i}
              className={`gallery-item ${i === 0 ? "big" : ""}`} // 🔥 FIX
            >
              <img src={img.src} alt={img.title} />

              <div className="gallery-overlay">
                <span>{img.title}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="gallery-footer">
          <button
            className="view-all-btn"
            onClick={() => navigate("/gallery")}
          >
            View Full Gallery →
          </button>
        </div>

      </div>
    </section>
  );
}